import { Component, OnInit, inject } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { AuthService } from '../../../common/services/auth.service';
import { concatMap, finalize, switchMap, tap, delay } from 'rxjs';
import { AppStateService } from '../../../common/store/state/app/app.state.service';
import { OrderService } from '../../../common/services/order/order.service';
import { SamlService } from '../../../common/services/saml.service';
import { UserStateService } from '../../../common/store/state/user/user.state.service';
import { OrderResumeStateService } from '../../../common/store/state/lic/order-resume-state-service';

@Component({
  selector: 'app-saml-auth',
  standalone: false,
  templateUrl: './saml-auth.component.html',
  styleUrl: './saml-auth.component.scss'
})
export class SamlAuthComponent extends BaseComponent implements OnInit {
  private authService = inject(AuthService);
  private orderService = inject(OrderService);
  private appStateService = inject(AppStateService)
  private samlService = inject(SamlService);
  private orderResumeStateService = inject(OrderResumeStateService)
  private userStateService = inject(UserStateService);

  uniqueId: string | null = null;
  samlData: any = null;
  ngOnInit(): void {
    // if (this.userStateService.getIsLoggedIn()) {
    //   console.log('User already logged in, redirecting to service information');
    //   return;
    // }
    // Grab uniqueId from query parameters
    this.uniqueId = this.route.snapshot.queryParamMap.get('uniqueId');

    // portal-qa.saraplus.com
    if (this.uniqueId) {
      console.log('SAML Auth - Unique ID received:', this.uniqueId);
      // First fetch token and session, then get SAML data
      this.fetchTokenAndSession();
    } else {
      console.warn('SAML Auth - No uniqueId found in query parameters');
    }
  }

  fetchTokenAndSession() {
    if (this.uniqueId) {
      const spinnerLabel = 'Fetching session and token...';
      this.spinnerService.setLoading(true, spinnerLabel);

      this.subscriptions.add(this.authService.fetchToken().pipe(
        concatMap(() => this.authService.fetchSession()),
        tap((session) => this.appStateService.setSession(session)),
        concatMap(() => this.orderService.processSAML(this.uniqueId)),
        tap((response) => this.orderResumeStateService.setSamlPayload(response)),
        delay(2000),
        concatMap(() => this.samlService.processResponse()),
        switchMap(() => this.redirect()),
        finalize(() => this.spinnerService.setLoading(false, spinnerLabel))
      ).subscribe());
    }
  }

  private redirect() {
    const route = this.samlService.getSamlNextPage();
    return this.router.navigate([route])
  }
}
